/* OAY cart drawer: size switching on a cart line, and the free-tee "Change" links. */
(function () {
  if (window.__oayCart) return;
  window.__oayCart = true;

  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
  }
  function refresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    }).catch(function () {});
  }
  function busy(sel, on) {
    var li = sel.closest('line-item'); if (!li) return;
    var l = li.querySelector('.line-item__loader');
    if (l) { l.hidden = !on; if (l.firstElementChild) l.firstElementChild.hidden = !on; }
    sel.disabled = on;
  }

  // change size: swap the line for the chosen variant, same quantity and properties
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('select[data-oay-swap]')) return;
    var key = sel.getAttribute('data-key');
    var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    var props = {};
    try { props = JSON.parse(sel.getAttribute('data-props') || '{}') || {}; } catch (err) {}
    if (Array.isArray(props) || typeof props !== 'object') props = {};   // Liquid prints empty properties as []
    var oldId = null;
    for (var i = 0; i < sel.options.length; i++) if (sel.options[i].defaultSelected) oldId = sel.options[i].value;
    var newId = sel.value;
    if (!newId || newId === oldId) return;
    busy(sel, true);
    // add the new size first; only remove the old line once that worked, so a failure never empties the line
    var item = { id: parseInt(newId, 10), quantity: qty };
    if (Object.keys(props).length) item.properties = props;
    post('/cart/add.js', { items: [item] })
      .then(function (r) {
        if (!r.ok) {
          sel.value = oldId;
          alertless((r.data && (r.data.description || r.data.message)) || 'That size could not be added.');
          return;
        }
        // line keys change after any cart update, so find the old line again by its variant
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (x) { return x.json(); }).then(function (cart) {
          var old = (cart.items || []).filter(function (it) {
            return String(it.variant_id) === String(oldId) && !(it.properties && it.properties._oay_gift);
          })[0];
          if (old) return post('/cart/change.js', { id: old.key, quantity: 0 });
        });
      })
      .catch(function () {})
      .then(function () { busy(sel, false); refresh(); });
  });

  // a small inline notice instead of a browser alert
  function alertless(msg) {
    if (!msg) return;
    var d = document.getElementById('mini-cart'); if (!d) return;
    var n = document.createElement('p');
    n.textContent = msg;
    n.style.cssText = 'margin:10px 12px 0;padding:10px 12px;border-radius:10px;background:#FFF4E5;color:#7A4B00;font-size:12.5px;';
    var body = d.querySelector('.drawer__content');
    if (body) { body.insertBefore(n, body.firstChild); setTimeout(function () { n.remove(); }, 5000); }
  }

  // free-tee "Change" / "Pick size & colour" opens the picker from oay-gift.js
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-oay-gift-change]');
    if (!b) return;
    e.preventDefault();
    if (window.oayGift && window.oayGift.open) window.oayGift.open();
  });

  // hide the floating free-tee pill while the drawer is open
  var obs = new MutationObserver(function () {
    var d = document.getElementById('mini-cart');
    document.documentElement.classList.toggle('oay-cd-open', !!(d && d.hasAttribute('open')));
  });
  function watch() { var d = document.getElementById('mini-cart'); if (d) obs.observe(d, { attributes: true, attributeFilter: ['open'] }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
